export function getDomain(host: string): string | null {
    return null;
}
